module.exports = __webpack_public_path__ + "mobile/img/wxMarket-img2.c8dfdc3d.png";